import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaPrint } from 'react-icons/fa';
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "../../Styles/yellowcalfcss/ExpensesView.css";
import ApiConfig from '../../api/ApiConfig';
import { simplePostCall } from '../../api/ApiServices';
import ScaleLoader from "react-spinners/ScaleLoader";

const ExpenseViewNew = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [expenseData, setExpenseData] = useState([]);

  const fetchExpensesDetails = useCallback(async () => {
    setLoading(true);
    try {
      const requestBody = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1609,
        api_key: localStorage.getItem("api_key") || "8440d41adb8335314263dc31d4504cf7",
        user_id: Number(localStorage.getItem("user_id")) || 56950,
        language: "en",
        id: id 
      };

      const response = await simplePostCall(ApiConfig.expensesListView, JSON.stringify(requestBody));

      if (response?.result && response?.data) {
        setExpenseData(response.data);
      } else {
        toast.error("Expense not found");
      }
    } catch (error) {
      console.error("Error fetching expense details:", error);
      toast.error("Failed to load details");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (id) fetchExpensesDetails();
  }, [id, fetchExpensesDetails]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div className="text-center p-2">
         <ScaleLoader color="#F4BB44" />
      </div>
    );
  }

  const mainInfo = expenseData[0] || {};

  return (
    <>
      {/* --- PRINT CSS START --- */}
      <style>
        {`
          @media print {
            /* Hide Sidebar, Navbar, and Action Buttons */
            .sidebar, 
            .navbar, 
            .header,
            .expenses-view-bill-1-header-actions, 
            .expenses-view-bill-1-print-box {
              display: none !important;
            }

            /* Ensure the main container expands to full width */
            .expenses-view-bill-1-container {
              width: 100% !important;
              margin: 0 !important;
              padding: 20px !important;
              border: none !important;
            }

            /* Remove any fixed positioning that might clip content */
            body, html {
              height: auto !important;
              overflow: visible !important;
            }
          }
        `}
      </style>
      {/* --- PRINT CSS END --- */}

      <ToastContainer />
      <div className="expenses-view-bill-1-header-row">
        <h1 className="expenses-view-bill-1-page-title">Expense Details</h1>

        <div className="expenses-view-bill-1-header-actions">
          <button className="expenses-view-bill-1-btn expenses-view-bill-1-btn-print" onClick={handlePrint}>
            Print <FaPrint style={{ marginLeft: "5px" }} />
          </button>
        </div>
      </div>

      <div className="expenses-view-bill-1-container">
        <div className="expenses-view-bill-1-info">
          <span><strong>Expense No:</strong> {mainInfo.expenses_number}</span>
          <span><strong>Account Type:</strong> {mainInfo.expense_account_type_name}</span>
          <span><strong>Date:</strong> {mainInfo.expenses_date}</span>
        </div>

        <table className="expenses-view-bill-1-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Items</th>
              <th>Quantity</th>
              <th>Unit Price</th>
              <th>Item Total</th>
            </tr>
          </thead>

          <tbody>
            {expenseData.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.expense_type_name}</td>
                <td>{item.expense_item_quantity}</td>
                <td>{item.expense_type_price}</td>
                <td>{item.expenses_total_amount}</td>
              </tr>
            ))}

            <tr className="expenses-view-bill-1-total-row">
              <td colSpan="3"></td>
              <td className="total-label">Total Expense</td>
              <td className="total-value">{mainInfo.expenses_total_amount}</td>
            </tr>
          </tbody>
        </table>

        <div className="expenses-view-bill-1-print-box">
          <button className="expenses-view-bill-1-print-btn" onClick={handlePrint}>
            Print 🖨
          </button>
        </div>
      </div>
    </>
  );
};

export default ExpenseViewNew;